import React from 'react';
import { Empty } from 'antd';
import {
  CATEGORY_EXCEPTIONS_MODAL_HEIGHT,
  ExceptionsModalDisplayType,
} from '../../../screens/Modals/CategoryExceptionsModal/categoryExceptionsModalLib';
import { ColumnScroll } from '@ydistri/ds';
import { useExceptions } from '../../../hooks/useExceptions';
import { ROOT_CATEGORY_ID } from '../_constants';
import ExceptionsByCategoryListing from './ExceptionsByCategoryListing';
import ExceptionsByFieldListing from './ExceptionsByFieldListing';

interface CategoryExceptionsModalContentProps {
  displayType: ExceptionsModalDisplayType;
  startCategoryId?: number;
  fullHeight?: boolean;
}

/**
 * Lists configuration exceptions in a given category and all its subcategories.
 * Allows modifying the configuration or removing the exceptions
 * @param displayType Group exceptions either by Field or Category
 * @param startCategoryId Id of the category to use as top category, defaults to Root category
 * @param fullHeight content should take almost all screen height or auto
 */
const CategoryExceptionsListing: React.FC<CategoryExceptionsModalContentProps> = ({
  displayType,
  startCategoryId = ROOT_CATEGORY_ID,
  fullHeight = true,
}) => {
  const exceptions = useExceptions(startCategoryId);

  if (exceptions.length === 0) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No exceptions" />;
  }

  return (
    <ColumnScroll
      $height={fullHeight ? CATEGORY_EXCEPTIONS_MODAL_HEIGHT : 'auto'}
      $gap="2rem"
      $minWidth="800px"
    >
      {displayType === ExceptionsModalDisplayType.FIELD ? (
        <ExceptionsByFieldListing categoryId={startCategoryId} />
      ) : (
        <ExceptionsByCategoryListing categoryId={startCategoryId} />
      )}
    </ColumnScroll>
  );
};

export default CategoryExceptionsListing;
